/**
 * List of events used by booking steps widget
 *
 */
export const bookingOptionalAncillariesPopup = {
  CLOSE_BUTTON_CLICKED: 'bookingOptionalAncillariesPopup.CloseButtonClicked',
  ACCEPT_BUTTON_CLICKED: 'bookingOptionalAncillariesPopup.AcceptButtonClicked'
}
